import React, { useEffect, useState } from 'react'
import NavBar from '../components/NavBar'
import PageSummary from '../components/PageSummary/PageSummary'
import SampleData from '../sampledata.json'
import { Accomodation as AccomodationInterface } from '../others/accomodation.interfaces'
import { repeat } from '../others/oneliners'
import AccomodationSlider from '../components/Accomodation/AccomodationSlider'
import Footer from '../components/Footer.signedout'
import Banner from '../components/banner/Banner'
import Partners from '../components/partners/Partners'
import Subscribe from '../components/newsletter/Subscribe'
// import { Review } from '../others/review.interfaces'
// import ReviewBar from '../components/Accomodation/ReviewBar'
// import Liked from '../components/Accomodation/Liked'
// import AllAccomodations from '../components/Accomodation/AllAccomodations'

function Accomodations() {
    // const [liked, setLiked] = useState<AccomodationInterface[] | null>(null)
    // const [allAccomodations, setAllAccomodations] = useState<AccomodationInterface[] | null>(null)
    // const [reviews, setReviews] = useState<Review[] | null>(null)
    const [suggestions, setSuggestions] = useState<AccomodationInterface[] | null>(null)
    useEffect(() => {
        setTimeout(() => {
            setSuggestions(repeat<AccomodationInterface>(SampleData.accomodations[0], 8))
            // setReviews(repeat<Review>(SampleData.reviews[0], 2))
            // setLiked(repeat<AccomodationInterface>(SampleData.accomodations[0], 5))
            // setAllAccomodations(repeat<AccomodationInterface>(SampleData.accomodations[0], 8))
        }, 2000)
    }, [])
    return (
        <>
            <main className='w-full'>
                <NavBar absolutelyPositioned transparent textColor='white' />
                {/* <PageSummary
                    bgImage='https://picsum.photos/1000'
                    title="Accomodations."
                    description='Lorem ipsum dolor sit amet consectetur adipisicing elit. Laudantium quo at rerum adipisci, pariatur optio odit ipsum voluptate porro fugiat.'
                /> */}
                <PageSummary />
                <main className='bg-[#ffffff]'>
                    <AccomodationSlider
                        suggestions={suggestions}
                        title={'Most rated accomodations'}
                        subtitle={'Book a living room or a house'}
                    />
                    <AccomodationSlider
                        suggestions={suggestions}
                        title={'Based on your location'}
                        subtitle={'Book a living room or a house'}
                    />
                    <Banner 
                        button='All available cars'
                        img='/carcrop.png'
                        title='Rent a car'
                        subtitle='You will not struggle to find a car'

                    />
                    <AccomodationSlider
                        suggestions={suggestions}
                        title={'Most rated accomodations'}
                        subtitle={'Book a living room or a house'}
                    />
                    <AccomodationSlider
                        suggestions={suggestions}
                        title={'Based on your location'}
                        subtitle={'Book a living room or a house'}
                    />
                    <Partners 
                        imgs={repeat('partner', 8).map((partner, i) => `/${partner}${i+1}.png`)}
                    />
                    <Subscribe />
                    {/* <ReviewBar reviews={reviews} /> */}
                    {/* <Liked liked={liked} /> */}
                    {/* <AllAccomodations accomodations={allAccomodations} /> */}
                </main>


            </main>
            <Footer />
        </>
    )
}

export default Accomodations